import React from "react";
import { useMessageSource } from "react-message-source";
import { ChangeEventHandler } from "../../../../ui/widgets/types";
import TextInputField from "../formik/text-input";

export default function LastName({
  forceReRender,
  dataPath = "",
  value,
  onChange,
  shrinkLastNameLabel,
}: {
  forceReRender?: boolean;
  dataPath?: string;
  value: string;
  onChange?: ChangeEventHandler;
  shrinkLastNameLabel?: boolean;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <TextInputField
      forceReRender={forceReRender}
      shrink={shrinkLastNameLabel}
      name={`${dataPath}lastName`}
      label={getMessage("Person.lastName")}
      value={value}
      onChange={onChange}
    />
  );
}
